import { DisaggregatedMetric, OrganizationMetricsProps } from "../services/types";
import { organizationMetricsMap } from "../utils/chartUtils";
import { getSvgMap, organizationNameMap } from "../utils/dashboardUtils";
import SimpleDonutChart from "./charts/SimpleDonutChart";
import MetricCard from "./MetricCard";
import MetricCardAlt from "./MetricCardAlt";

const OrganizationMetrics = ({ orgId, indicators, metadata, categorizedData, tab }: OrganizationMetricsProps) => {
    if (!orgId) return;

    const orgMetrics = organizationMetricsMap[orgId]; // Fetch the org's metrics map based on the orgId

    if (!orgMetrics) {
        return <div className="flex items-center justify-center">No metrics available for this organization.</div>;
    }

    // Access the specific category based on the "tab" prop
    const category = orgMetrics[tab];

    if (!category) {
        return <div className="flex items-center justify-center">No metrics available for this category.</div>;
    }

    const { card, donut, cardalt } = category;

    const orgName = organizationNameMap[orgId];

    // Loop through each category (Demographic, Education, etc.)
    return (
        <>
            <p className="text-xs text-center text-port-text mt-4">Below are the key metrics related to the <strong>{orgName}</strong>.</p>
            {/* Render cards from the "card" array */}
            {card && card.length > 0 && (
                <div className="grid grid-cols-3 gap-4 place-items-start ml-4">
                    {card.map((metricId: number) => {
                        const metric: DisaggregatedMetric = categorizedData[tab]?.find((metric: any) => metric.id === metricId);
                        return metric ? (
                            <MetricCard
                                key={metric.id}
                                metric={metric}
                                width="w-full"
                                svg={getSvgMap(orgId, metric.id)}
                                metadata={metadata}
                            />
                        ) : null;
                    })}
                </div>
            )}

            {/* Render cards from the "cardalt" array */}
            {cardalt && cardalt.length > 0 && (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-4 place-items-center mx-4 my-2">
                    {cardalt.map((metricId: number) => {
                        const metric: DisaggregatedMetric = categorizedData[tab]?.find((metric: any) => metric.id === metricId);
                        return metric ? (
                            <MetricCardAlt
                                key={metric.id}
                                metric={metric}
                                width="w-full"
                                svg={getSvgMap(orgId, metric.id)}
                                metadata={metadata}
                            />
                        ) : null;
                    })}
                </div>
            )}

            {/* Render donut charts from the "donut" array */}
            {donut && donut.length > 0 && donut.map((donutData: any) => (
                <SimpleDonutChart
                    key={donutData}
                    id={donutData}
                    indicators={indicators}
                    currentTab={tab}
                    fillColor="port-blue"
                    remainColor="#4D4D4D"
                    valueColor="port-green"
                />
            ))}

            {/* Render race/ethnicity or other charts from the "race" array */}
            {/* {race && race.length > 0 && race.map((chartData: any) => {
                return (
                    <div key={chartData.id} className="col-span-2 w-full pl-4">
                        {categorizedData.Demographic.filter((metric: any) => 
                            [getMetricGroupChartId(orgId, tab, chartData.name)].includes(metric.id)
                        ).map((metric: any) => (
                            <DisaggregateMetricCard
                                key={metric.id}
                                id={metric.id}
                                title={"Race & Ethnicity"}
                                metadata={metadata}
                            />
                        ))}
                        <RaceEthnicityChart
                            indicators={indicators}
                            title={chartData.name}
                            tab={tab}
                            chartName={chartData.name}
                            height="h-64"
                            barColor="#00A18A"
                            reverseOrder={false}
                            topFive={false}
                        />
                    </div>
                );
            })} */}
        </>
    );
};

export default OrganizationMetrics;
